import { db } from '../FirebaseLibrary';
import { cachedFirestoreFetch } from './FirestoreFetchCache';

export const createPlayersReference = () => {
    return db.collection('players');
};

export const createPlayerReference = (playerId: string) => {
    return createPlayersReference().doc(playerId);
};

// Cached: game-stat enrichment resolves a player doc per goal/assist/penalty/tag line,
// so the same player is requested many times in one pass (and again across tabs).
export const fetchPlayerFirestoreAPI = (playerId: string) => {
    return cachedFirestoreFetch(`player|${playerId}`, () => {
        return createPlayerReference(playerId).get();
    });
};

export const fetchAllPlayersFirestoreAPI = (teamId: string) => {
    return createPlayersReference().where('teamId', '==', teamId).where('deleted', '==', false).get();
};

export const fetchPlayersFirestoreAPI = (teamId: string) => {
    return cachedFirestoreFetch(`players|${teamId}`, () => {
        return createPlayersReference().where('teamId', '==', teamId).where('alumni', '==', false).where('deleted', '==', false)
            .orderBy('name')
            .get();
    });
};

export const fetchLimitedPlayersFirestoreAPI = (teamId: string, count: number) => {
    return createPlayersReference().where('teamId', '==', teamId).where('alumni', '==', false).where('deleted', '==', false)
        .orderBy('name')
        .limit(count)
        .get();
};

export const fetchAlumniFirestoreAPI = (teamId: string) => {
    return createPlayersReference().where('teamId', '==', teamId).where('alumni', '==', true).where('deleted', '==', false)
        .orderBy('name')
        .get();
};

export const fetchLimitedAlumniFirestoreAPI = (teamId: string, count: number) => {
    return createPlayersReference().where('teamId', '==', teamId).where('alumni', '==', true).where('deleted', '==', false)
        .orderBy('name')
        .limit(count)
        .get();
};
